
import api from '../api/apiClient'
import type { User, UserSubscription } from '../models/user'

export const usersRepository = {
  getMe: async (): Promise<User> => {
    const response = await api.get('/users/me')
    return response.data.data
  },

  getMySubscriptions: async (): Promise<UserSubscription[]> => {
    const response = await api.get('/users/my-subscriptions')
    return response.data.data
  },

  requestEmailVerification: async (): Promise<void> => {
    await api.post('/users/resend-verification')
  },

  verifyEmail: async (otp: string): Promise<void> => {
    await api.post('/users/verify', { token: otp })
  },

  linkTelegram: async (otp: string): Promise<void> => {
    await api.post('/users/link-telegram', { link_code: otp })
  },

  linkCryptoWallet: async (address: string): Promise<void> => {
    await api.post('/wallets/link-wallet', { wallet_address: address })
  }
}